export default __webpack_public_path__ + "static/media/fooddiary_cover.4cf48de1.jpg";